export const DEFAULT_ROW_PROCEDIMIENTOS_INGRESO = {
  secuencia: 0,
  key: 0,
  cobertura: "",
  nombreCobertura: "",
  tipoReclamante: "",
  codigoReclamante: "",
  nombreReclamante: "",
  limiteContrato: "",
  frecuencia: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
  coaseguro: "",
  honorarios: "",
  esNuevo: false,
};

export const MAXIMO_DIAS_PERMITIDOS_CIERRE = {
  CON_PRECERTIFICACION_CALENDARIO: 2,
  SIN_PRECERTIFICACION_CALENDARIO: 5,
  CON_EXEPCION_CALENDARIO: 2,
  CONSULTAR_INGRESO_CON_PRECERTIFICACION: 32,
  CONSULTAR_INGRESO_SIN_PRECERTIFICACION: 35,
};

export const CONFIGURACION_COBERTURAS_NO_PERMITIDAS = [1068, 3210, 3211];

export const COBERTURA_VALIDACION = {
  HABITACION_DIARIA: 1064,
  OXIGENO: 1083,
};

export const SERVICIO_EXCEPCION = {
  PARTO: 11,
  CESAREA: 12,
  HOSPITALIZACION: 2,
};

export const ESTATUS_COBERTURA = {
  VIGENTE: 61,
};

export const MAX_LENGTH_LITROS = 6;

export const ESTATUS_INGRESO = {
  VIGENTE: "VIGENTE",
  CONVERTIDO: "CONVERTIDO",
};

export const RESPUESTA_PILOTO_CIERRE_CUENTAS = {
  AMBOS: "A",
  HOJA_QUIRURGICA: "C",
  CIERRE_CUENTA: "S",
  SIN_ACCESO: "N"
};

export const USUARIO_WEB = "WEBSALUD";

export const COMENTARIO_POR_DEFECTO = "N/A";

export const CAUSA_POR_DEFECTO = "Consulta";

export const ESTATUS_PERMITIDO = ESTATUS_INGRESO.VIGENTE;

export const MENSAJE_CIERRE_CUENTA = {
  INGRESO_NO_EXISTE:
    "Estimado PSS, el número de ingreso que has digitado no puede ser completado por esta vía. Para completar el proceso de cierre de la cuenta favor de ponerse en contacto con el equipo de contact center al 809-476-3535.",
  INGRESO_REQUIERE_PROCEDIMIENTOS:
    "El ingreso debe tener por lo menos un procedimiento.",
  DIAS_MAXIMOS_PERMITIDOS:
    "Estimado PSS, no es posible completar el cierre de la cuenta clínica debido a que excede el máximo de días permitidos por esta vía. Para poder proceder favor de ponerse en contacto con el equipo de Contact Center al número 809-476-3333 opción 1.",
  DIAS_CALENDARIO_EXCEDIDOS:
    "Estimado PSS, el ingreso ha superado la cantidad de días permitidos por esta vía. Para poder proceder con el cierre de la cuenta, favor de ponerse en contacto con el Contact Center al número 809-476-3333 opción 1",
  DIAS_CALENDARIO_EXCEDIDOS_EXCEPCION:
    "Estimado PSS, no es posible completar el proceso de cierre de cuenta clínica por esta vía. Favor de ponerse en contacto con el Contact Center al 809-476-3333 opción 1",
  FECHA_SERVICIO_EXCEDE_SALIDA:
    "La fecha de salida no puede ser menor a la fecha de servicio.",
  FECHA_SALIDA_EXCEDE_ACTUAL:
    "La fecha de salida no puede ser mayor a la fecha de hoy.",
  COBERTURA_SERVICIO_NO_PERMITIDA:
    "Por esta vía no tiene permiso pasar esta cobertura bajo el servicio seleccionado.",
  EXCEDE_MONTO_MAXIMO:
    "El monto digitado para la cobertura codigoCobertura excede el monto máximo permitido. Para procesar el cierre de la cuenta, por favor póngase en contacto con el equipo de Contact Center al 809-476-3535.",
};

export const RAMO_INGRESO = {
  PRIMERA: 94,
};

export const MAXIMO_DIAS_CONSULTA_CIERRES = 60;

export const TIPO_SERVICIO_PERMITIDO = [
  {
    key: 1,
    label: "Ambulatorio",
    value: "1",
  },
  {
    key: 2,
    label: "Hospitalización",
    value: "2",
  },
  {
    key: 5,
    label: "Maternidad",
    value: "5",
  },
  {
    key: 11,
    label: "Parto",
    value: "11",
  },
  {
    key: 12,
    label: "Cesárea",
    value: "12",
  },
];

export const CODIGO_CONTRATO_OXIGENO = {
  LITRO: "1",
  MONTO: "2",
};

export const CONTRATO_OXIGENO = [
  {
    key: 1,
    label: "Litro",
    value: "1",
  },
  {
    key: 2,
    label: "Monto",
    value: "2",
  },
];

export const TIPO_PSS_NO_MEDICO_JIRA = "12909";
export const PLAN_PDSS_JIRA = "12675";
export const CANAL_OFV_JIRA = "OFV";
export const STATUS_PERMITE_EDITAR_JIRA = "Cerrada por falta de documentación y/o información";
export const MAXIMO_MEDICOS_ADICIONALES = 5;

export const OpcionesTipoServicio = [
  { label: "Seleccionar", value: "" },
  { label: "Hospitalización", value: "Hospitalización" },
  { label: "Accidente de tránsito", value: "Accidente de tránsito" },
  { label: "Alto costo", value: "Alto costo" },
  { label: "Cesárea", value: "Cesárea" },
  { label: "Parto", value: "Parto" },
  { label: "Maternidad", value: "Maternidad" }
];

export const OpcionesEstatus = [
  { label: "Seleccionar", value: "" },
  { label: "Abierta", value: "Abierta" },
  { label: "Cerrado", value: "Cerrado" },
  { label: "En validación", value: "En validacion" },
  { label: "Declinado", value: "Declinado" },
  { label: "Devuelta falta de información", value: STATUS_PERMITE_EDITAR_JIRA },
  { label: "Cerrado satisfactoriamente", value: "Cerrado satisfactoriamente" },
  { label: "Asignado a Contrataciones", value: "Asignado a Contrataciones" },
  { label: "Asignada a Backoffice", value: "Asignada a Backoffice" }
];

export const HOMOLOGACION_ESTATUS_INGRESO = {
  58: "VIGENTE",
  59: "CANCELADO",
  60: "CONVERTIDO",
  181: "PRE-AUTORIZADO",
  182: "DECLINADO",
  993: "PENDIENTE APROBACIÓN",
  362: "CANCELADA -/PAGO",
  997: "CANCELADO",
  741: "COMPROBACIÓN",
  522: "PDSS SUPLEMENTARIEDAD AUDITORIA",
  524: "CANCELADO EN ASEGURADORA",
  527: "CONVERTIDA RECLAMACIÓN SUPLEMENTARIA",
};

export const FORMATOS_ADJUNTOS_PERMITIDOS =
  ".pdf,.doc,.docx,.jpg,.jpeg,.png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-word";


